<template>
  <svg
    class="svg-icon"
    :style="svgStyle"
    aria-hidden="true"
  >
    <use :xlink:href="`/svg/spritemap.svg${iconName}`" :fill="fill" />
  </svg>
</template>

<script setup lang="ts">
import { computed, defineProps } from 'vue';

const props = defineProps({
  // 图标名称（对应 SVG 文件名，不含扩展名）
  name: {
    type: String,
    required: true
  },
  // 图标颜色，默认继承父元素的 color
  fill: {
    type: String,
    default: '#64748B'
  },
  // 图标大小，可以是数字（px）或字符串（如 '1.5em'）
  size: {
    type: [Number, String],
    default: 24
  },
  // 自定义前缀（如果插件配置了 prefix 选项）
  prefix: {
    type: String,
    default: 'sprite-' // 与插件默认 prefix 保持一致
  }
});

// 计算图标在雪碧图中的完整 ID
const iconName = computed(() => {
  return `#${props.prefix}${props.name}`;
});

// 计算 SVG 样式
const svgStyle = computed(() => {
  const sizeValue = typeof props.size === 'number' ? `${props.size}px` : props.size;
  return {
    width: sizeValue,
    height: sizeValue
  };
});
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: middle;
  /* 确保 fill 可以被子元素继承 */
  fill: currentColor;
}
</style>